"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getQuickBuyButtonOnClickHandlers = void 0;
var _openProductInfoDialog = _interopRequireWildcard(require("@ori-events/open-product-info-dialog"));
var OpenProductInfoDialog = _openProductInfoDialog;
var _analyticsData = require("@ori/analytics-data");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const createHandler = (mode, productCode)=>()=>{
        window.dispatchEvent(new CustomEvent(OpenProductInfoDialog.Name, {
            detail: {
                mode,
                placement: _analyticsData.Placement.ProductListing,
                productCodes: [
                    productCode
                ]
            }
        }));
    };
const getQuickBuyButtonOnClickHandlers = (productCode)=>{
    const onNotifyMeButtonClick = createHandler(_openProductInfoDialog.DialogMode.StandardBuy, productCode);
    return {
        onNotifyMeButtonClick
    };
};
exports.getQuickBuyButtonOnClickHandlers = getQuickBuyButtonOnClickHandlers;
